import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { contentAPI } from '@/providers/apis/content-ingestion/content-ingestion';
import { sessionService } from '@/providers/services/auth/session';
import UploadStatusComponent from '@/components/catalog/upload-popup/upload-popup.vue';
import { authAPI } from '@/providers/apis/auth/auth';
import { appConfigService } from '@/providers/services/app/app-config';
import { INGESTION_CSV_FORMATS } from '@/utils/constants';
import { watch } from 'vue';

@Component({
  name: 'bulk-upload',
  components: {
    'material-icon': GoogleMaterialIcon,
    'mc-icon': MCIcon,
    'upload-popup': UploadStatusComponent,
  },
})
export default class BulkUpload extends Vue {

  public file: any;
  public payload = {};
  public offset = 0;
  public limit = 10;
  public currentPage = 1;
  public totalItems: number = 0;
  public dismissCountDown: number = 0;
  public uploadDetails: any = [];
  public filterDetails: any = {};
  public csvFile: any = null;
  public isLoader: boolean = false;
  public isUploadState: boolean = false;
  public isUploadLoading: boolean = false;
  public itemsId: string = '';
  public itemStatus: string = '';
  public timer: any = '';
  public productLists: any = [];
  public isProductName: boolean = false;
  public isProductDesc: boolean = false;
  public questionUploadRes: any = null;
  public courseUploadRes: any = null;

  public contentTypes: any = [
    {name: 'Course'},
    {name: 'Resources'},
    {name: 'Questions'},
  ];

  public selectedContentType: any = null;

  public selectedProductName: any = null;

  public isCourseView: boolean = false;
  public isresourceView: boolean = false;
  public isQuestionView: boolean = false;
  public isCreateProductPopup: boolean = false;
  public clientDetail: any = null;
  public bearerToken: any = null;
  public sampleFormat: any;


  public fieldsItem: any = [
    {
      key: 'index',
      label: 'S.No',
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',
    },
    {
      key: 'name',
      label: 'File Name',
      sortable: false,
      thClass: 'text-center',
    },
    {
      key: 'uploadDate',
      label: 'Uploaded Date',
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',
    },
    {
      key: 'resourceCount',
      label: 'Resource Counts',
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',
    },
    {
      key: 'processCount',
      label: 'Processed Counts',
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',
    },
    {
      key: 'errorCount',
      label: 'Error Counts',
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',
    },
    {
      key: 'status',
      label: 'Status',
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',
    },
  ];
  private searchText: string = '';
  private searchProduct: string = '';
  private productName: string = '';
  private productDesc: string = '';

  // methods
  public created() {
    this.isCourseView = true;
    this.sampleFormat = INGESTION_CSV_FORMATS.course;
    this.getUpdateDetails();
    this.selectedContentType = this.contentTypes[0];
    this.getProductList();
    authAPI.getClientDetail(this.getTenantId()).then((response) => {
      this.clientDetail = response[0];
      const params = {
        grant_type: 'client_credentials',
        client_id: this.clientDetail.client_id,
        client_secret: this.clientDetail.client_secret,
      };
      authAPI.getBearerToken(params).then((res: any) => {
        this.bearerToken = res.access_token;
      });
    });
  }

  // content-request
  public loadContent(page: number) {
    this.currentPage = page;
    this.offset = (page - 1) * this.limit;
    this.getUpdateDetails();
  }

  public getUpdateData() {
    this.uploadDetails = [];
    this.getUpdateDetails();
  }

  public async getUpdateDetails() {
    this.isLoader = true;
    this.filterDetails.request_type = 'CSV';
    this.filterDetails.limit = this.limit;
    this.filterDetails.offset = this.offset;
    this.filterDetails.user_id = this.getUserId();
    this.filterDetails.tenant = this.getTenantId();
    let uploadApiPromise;
    this.uploadDetails = [];
    const param = {
      limit: this.limit,
      offset: this.offset,
      q: this.searchText ? this.searchText : '',
      tenant: this.getTenantId(),
    };
    if (this.isCourseView) {
       contentAPI.getCourseList(param).then((res) => {
        this.isLoader = false;
        this.csvFile = null;
        this.uploadDetails = [...res.content];
        this.totalItems = res.count;
      });
    }
    if (this.isresourceView) {
      uploadApiPromise =   contentAPI.uploadsContentRequest(this.filterDetails);
      if (uploadApiPromise) {
        uploadApiPromise.then((response) => {
          this.isLoader = false;
          this.csvFile = null;
          this.totalItems = response.count;
          this.uploadDetails =  response.content;
        });
      }
    }
    if (this.isQuestionView) {
       contentAPI.getQuestionList(param).then((res) => {
        this.isLoader = false;
        this.csvFile = null;
        this.uploadDetails =  res.content;
        this.totalItems =  res.count;
       });
    }
  }


  // get Upload Files Data
  public handleFileSelect(evt: any) {
    const files = evt.target.files; // FileList object
    this.file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(this.file);
    reader.onload = (event: any) => {
      const image = new Image();
      image.src = event.target.result;
    };
    this.isUploadState = true;
  }

 // Upload POST API
  public upload(contentType: any) {
    this.isUploadLoading = true;
    if (this.isUploadState) {
      if (this.selectedContentType.name === 'Course') {
        this.isUploadLoading = false;
        contentAPI.updateUploadFile(this.file).then((res: any) => {
          if (res) {
            const payload = {
              file_name: res.data.filename,
              uploaded_by: this.getUserId(),
              status: 'uploaded',
              tenant: this.getTenantId(),
              request_type: 'CSV',
              file_display_name : this.file.name,
            };
            contentAPI.CourseIngestion(payload).then((courseRes: any) => {
              this.courseUploadRes = courseRes;
              this.getUpdateDetails();
              this.csvFile = null;
              this.offset = 0;
              this.limit = 10;
              this.currentPage = 1;
            });
          }
        });

      }
      if (this.selectedContentType.name === 'Questions') {
        this.isUploadLoading = false;
        const formData = new FormData();
        formData.append('file', this.file);
        formData.append('tenant_id', this.getTenantId());
        contentAPI.questionUploadFile(formData, this.bearerToken).then((qsnRes: any) => {
          this.isUploadLoading = false;
          this.questionUploadRes = qsnRes;
          this.getUpdateDetails();
          this.csvFile = null;
          this.offset = 0;
          this.limit = 10;
          this.currentPage = 1;
        });
      }
      if (this.selectedContentType.name === 'Resources') {
        contentAPI.updateUploadFile(this.file).then((res: any) => {
          if (res) {
            this.payload = {
              file_name: res.data.filename,
              uploaded_by: this.getUserId(),
              status: 'uploaded',
              tenant: this.getTenantId(),
              request_type: 'CSV',
              file_display_name : this.file.name,
            };
            // After Upload Post the File Details
            contentAPI
              .uploadFile(this.payload)
              .then(() => {
                this.isUploadLoading = false;
                this.dismissCountDown = 2;
                this.csvFile = null;
                this.uploadDetails = [];
                this.offset = 0;
                this.limit = 10;
                this.currentPage = 1;
                this.getUpdateDetails();
              });
          }
        });
      }
  }
    this.isUploadState = false;
  }

  public getTenantId() {
    const userDetails: any = sessionService.getSession();
    return userDetails.tenant.tenant_id;
  }

  public getUserId() {
    const userDetails: any = sessionService.getSession();
    return userDetails.user_id;
  }

  // Actions

   public openPopup(data: any ) {
      this.itemStatus = data.errorCount;
      this.itemsId = data.id;
      this.$bvModal.show('modal-center');
  }

   public passRequestData(item: any) {
    window.location.href = `/catalog?type=my-content&&id=${item.jobId}&&filename=${item.name}&&uploadType=bulk-upload`;
  }

  public onClose() {
    this.searchText = '';
    this.uploadDetails = [];
    this.filterDetails.q = this.searchText;
    this.getUpdateDetails();
  }

  public onGoBack() {
    if (this.$router.currentRoute.query.redirectUrl === '/facet-search') {
      this.$router.push({
        path: `/facet-search`,
      });
    } else {
      this.$router.push({
        path: `/catalog`,
        query: {
          type: 'my-content',
        },
      });
    }
  }
  public onSelectContentTypes(content: any) {
    this.selectedContentType = content;
    if (content.name === 'Course') {
      this.sampleFormat = INGESTION_CSV_FORMATS.course;
      this.onCourseTab();
    }
    if (content.name === 'Resources') {
      this.sampleFormat = INGESTION_CSV_FORMATS.resource;
      this.onResourceTab();
    }
    if (content.name === 'Questions') {
      this.sampleFormat = INGESTION_CSV_FORMATS.question;
      this.onQuestionTab();
    }
  }
  public onSelectProductName(content: any) {
    this.selectedProductName = content;
  }
  public onSearchProduct() {
   this.searchProduct = '';

  }
  public onCreateProject() {
    this.isCreateProductPopup = true;
    const el: any = this.$el.querySelector(`.product-container .dropdown .dropdown-menu`);
    el.classList.remove('show');
  }
  public onCourseTab() {
    this.isCourseView = true;
    this.isresourceView = false;
    this.isQuestionView = false;
    this.offset = 0;
    this.limit = 10;
    this.currentPage = 1;
    this.getUpdateDetails();
  }
  public onResourceTab() {
    this.isresourceView = true;
    this.isCourseView = false;
    this.isQuestionView = false;
    this.offset = 0;
    this.limit = 10;
    this.currentPage = 1;
    this.getUpdateDetails();
  }
  public onQuestionTab() {
    this.isQuestionView = true;
    this.isresourceView = false;
    this.isCourseView = false;
    this.offset = 0;
    this.limit = 10;
    this.currentPage = 1;
    this.getUpdateDetails();
  }
  public getProductList() {
    const params: any = {
      offset: this.offset,
      limit: this.limit,
    };
    contentAPI.fetchProductList(params).then((registryList: any) => {
      this.productLists = registryList.contentRegistry;
    });
  }
  public onClosePopup() {
    this.isCreateProductPopup = false;
  }
  public onSave() {
    this.isProductName = false;
    this.isProductDesc = false;
    if (!this.productName || !this.productDesc) {
      if (!this.productName) {
        this.isProductName = true;
      }
      if (!this.productDesc) {
        this.isProductDesc = true;
      }
      return;
    }
    const params = {
      name: this.productName,
      description: this.productDesc,
    };
    contentAPI.savePublisher(params).then((registryList: any) => {
      this.productName = '';
      this.productDesc = '';
    });
  }

  public onClickAPI(data: any) {
    const params = {
      start_offset: 0,
      end_offset: data.item.resourceCount,
      limit: data.item.resourceCount,
      creator_system: 'Resource_Ingest_job_' + data.item.jobId,
      tenant: data.item.tenantId,
    };
    contentAPI.ResourceIngestJob(params);
  }

  private onSearch() {
    this.filterDetails.q = this.searchText;
    this.getUpdateDetails();
  }
}
